/* import "./styles.scss";
import ArticleListItem from "../article-list-item/index.vue";

export default {
  name: "ArticleList",

  components: {
    "list-item": ArticleListItem,
  },

  computed: {
    listItems() {
      return this.$store.getters.getArticleList(Number(this.$route.params.id));
    },

    list() {
      return this.$store.getters.getArticleGroup(Number(this.$route.params.id));
    },

    previous_list_item() {
      if (this.list.parent_topic) {
        return this.$store.getters.getArticleGroup(this.list.parent_topic);
      } else {
        return undefined;
      }
    },

    backURL() {
      let backURL;

      if (this.list.parent_topic === 10001) {
        // parent topic is emergency events
        backURL = "/action";
      }

      if (
        this.list.parent_topic === 10002 ||
        this.list.parent_topic === 10003
      ) {
        // parent topic is recovery or preparedness
        backURL = "/action/operations";
      }

      if (
        this.list.parent_topic === 10001 ||
        (this.previous_list_item &&
          (this.previous_list_item.id === 10001 ||
            this.previous_list_item.parent_topic === 10001))
      ) {
        // emergency events or emergency events base
        backURL = "/action/emergency-events";
      }

      if (
        this.list.parent_topic === 1002 ||
        (this.previous_list_item &&
          (this.previous_list_item.id === 10002 ||
            this.previous_list_item.parent_topic === 10002))
      ) {
        // recovery or recovery base
        backURL = "/action/operations/recovery";
      }

      if (
        this.list.parent_topic === 1003 ||
        (this.previous_list_item &&
          (this.previous_list_item.id === 10003 ||
            this.previous_list_item.parent_topic === 10003))
      ) {
        // preparedness or preparedness base
        backURL = "/action/operations/preparedness";
      }

      if (
        this.previous_list_item &&
        this.previous_list_item.id !== 10001 &&
        this.previous_list_item.id !== 10002 &&
        this.previous_list_item.id !== 10003
      ) {
        // add list to existing url
        backURL += `/list-${this.previous_list_item.id}`;
      }

      return backURL;
    },
  },

  methods: {
    async doLoad() {
      this.$store.commit("setMenuItems", this.listItems);
      // Check if list and list.name are valid before accessing
      if (this.list) {
        this.$store.commit("setMenuDetails", {
          title: this.list.name,
          slug: this.list.slug,
          back_url: this.backURL,
        });
      }
      return this.$store.dispatch("fetchArticles");
    },
  },

  created() {
    this.initNetworkLoad();
    this.$store.dispatch("getArticlesData").then(() => {
      this.doLoad();
    });
  },
};
 */

import "./styles.scss";
import ArticleListItem from "../article-list-item/index.vue";

export default {
  name: "ArticleList",

  components: {
    "list-item": ArticleListItem,
  },

  computed: {
    listItems() {
      return this.$store.getters.getArticleList(Number(this.$route.params.id));
    },

    list() {
      return this.$store.getters.getArticleGroup(Number(this.$route.params.id));
    },

    previous_list_item() {
      if (this.list.parent_topic) {
        return this.$store.getters.getArticleGroup(this.list.parent_topic);
      } else {
        return undefined;
      }
    },

    backURL() {
      let backURL;

      if (this.list.parent_topic === 10001) {
        // parent topic is emergency events
        backURL = "/action";
      }

      if (
        this.list.parent_topic === 10002 ||
        this.list.parent_topic === 10003
      ) {
        // parent topic is recovery or preparedness
        backURL = "/action/operations";
      }

      if (
        this.list.parent_topic === 10001 ||
        (this.previous_list_item &&
          (this.previous_list_item.id === 10001 ||
            this.previous_list_item.parent_topic === 10001))
      ) {
        // emergency events or emergency events base
        backURL = "/action/emergency-events";
      }

      if (
        this.list.parent_topic === 1002 ||
        (this.previous_list_item &&
          (this.previous_list_item.id === 10002 ||
            this.previous_list_item.parent_topic === 10002))
      ) {
        // recovery or recovery base
        backURL = "/action/operations/recovery";
      }

      if (
        this.list.parent_topic === 1003 ||
        (this.previous_list_item &&
          (this.previous_list_item.id === 10003 ||
            this.previous_list_item.parent_topic === 10003))
      ) {
        // preparedness or preparedness base
        backURL = "/action/operations/preparedness";
      }

      if (
        this.previous_list_item &&
        this.previous_list_item.id !== 10001 &&
        this.previous_list_item.id !== 10002 &&
        this.previous_list_item.id !== 10003
      ) {
        // add list to existing url
        backURL += `/list-${this.previous_list_item.id}`;
      }

      return backURL;
    },
  },

  created() {
    this.$store.dispatch("fetchArticles");
    this.$store.commit("setMenuItems", this.listItems);
    this.$store.commit("setMenuDetails", {
      title: this.list.name,
      slug: this.list.slug,
      back_url: this.backURL,
    });
  },
};
